import React from 'react';
import PropTypes from 'prop-types';
import FlatsFilters from '../../../FlatsFilters/FlatsFilters';

const PriceRange = ({ filterParams, searchParams }) => (
  <FlatsFilters.PriceRange
    type="full_price"
    event={{
      category: window.eventCategory,
      action: 'filters',
      label: 'full_price_click',
    }}
    rangeMin={filterParams.price.min_full_price}
    rangeMax={filterParams.price.max_full_price}
    minValue={
      searchParams.min_full_price
        ? Number(searchParams.min_full_price)
        : filterParams.price.min_full_price
    }
    maxValue={
      searchParams.max_full_price
        ? Number(searchParams.max_full_price)
        : filterParams.price.max_full_price
    }
    isFullRange
  />
);

PriceRange.propTypes = {
  filterParams: PropTypes.object,
  searchParams: PropTypes.object,
};

export default PriceRange;
